<template>
    <div class=" w-full text-gray-700 h-16 ">
        <jet-label class="text-white font-bold whitespace-nowrap col-span-6  z-10" v-bind:value="config.text"/>

        <jet-auto-complete
            :placeholder="config.text"
            :auto-load="true"
            :endpoint="config.endpoint"
            :multiple="false"
            :taggable="false"
            class="mt-1 block w-full placeholder-gray-50  h-10"
            v-model="selectedItemAutoComplete"
            @input="selectedAutoComplete"
        />
    </div>
</template>

<script>
import JetAutoComplete from "../../Jetstream/AutoComplete";
    import JetLabel from "../../Jetstream/Label";

    export default {
        components:{
            JetAutoComplete,
            JetLabel
        },
        props: {
            config: {
                default: () => {}
            },
            value: {
                type:  [String, Object,Boolean,Number,Array]
            },
        },
        watch: {
            value: function (val) {
                this.selectedItemAutoComplete = val;
            }
        },
        data() {
            return {
                selectedItemAutoComplete: this.value
            }
        },
        methods: {
            selectedAutoComplete() {
                this.$emit('input', this.selectedItemAutoComplete ? this.selectedItemAutoComplete : null);
            },
        }

    }
</script>
